import { OdinIcon } from '@myosh/odin-components';
import React, { type Dispatch, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { GetAnalysisJobStatusApiResponse } from '../../@types/background-jobs';
import useActiveRecordRef from '../../hooks/use-active-record-ref';
import type {
  AnalyzeRecordsBackgroundJobApiProps,
  BackgroundJobDetails,
} from '../../redux/slices/background-job-slice';
import { JobStatus, setIsPanelOpen } from '../../redux/slices/background-job-slice';
import BaseJobPanelItem from './base-job-panel-item.component';
import { useAppDispatch } from '../../redux/hooks';

interface AnalyzeRecordBackgroundJobItemProps {
  job: BackgroundJobDetails<AnalyzeRecordsBackgroundJobApiProps, GetAnalysisJobStatusApiResponse>;
  onRemove: () => void;
}

function AnalyzeRecordBackgroundJobItem({ job, onRemove }: AnalyzeRecordBackgroundJobItemProps) {
  const { t } = useTranslation();
  const { activeRecordReference } = useActiveRecordRef();
  const dispatch = useAppDispatch();

  const handleClick = useCallback(() => {
    if (job && job.details?.result && job.status === JobStatus.Success) {
      activeRecordReference.current?.addActiveRecord(job.id, 'FLASK', job.apiProps.formName, false, {
        isRecordAnalysis: true,
        analyzeRecordJobId: job.id,
        formId: job.apiProps.formId,
        viewId: job.apiProps.viewId,
        title: job.apiProps.formName,
        ...job.details?.result,
      });

      dispatch(setIsPanelOpen(false));
    }
  }, [job, activeRecordReference, dispatch]);

  return (
    <BaseJobPanelItem
      title={job.apiProps.formName}
      subtitle={t('analyse-records')}
      status={job.status}
      onRemove={onRemove}
      onClick={handleClick}
      icon={<OdinIcon icon="FlaskConical" />}
    />
  );
}

export default React.memo(AnalyzeRecordBackgroundJobItem);
